import { Box, Text, ActionIcon, Overlay, Button } from "@mantine/core";
import cx from "clsx";
import { useEffect } from "react";

import { useSidebar } from "@/src/contexts/sidebar-context";
import { openAiDrawerGlobally } from "@components/drawers/ai-drawer";
import {
  CustomSiderNavGroup,
  CustomSiderAvatarCard,
  CustomCurrentDatasetPopover,
  CustomAiRobot,
} from "@/src/components/custom";
import {
  navGroupCore,
  navGroupDistribution,
} from "@/src/components/data/nav-groups-data";
import { Datasets } from "@/src/components/data/current-dataset-popover-data";

import styles from "@scss/navigation/mobile-menu.module.scss";

export const MobileMenu = () => {
  const { isMobileMenuOpen, toggleMobileMenu, setIsMobileMenuOpen } =
    useSidebar();

  // Close menu on escape key
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape" && isMobileMenuOpen) {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMobileMenuOpen, setIsMobileMenuOpen]);

  if (!isMobileMenuOpen) return null;

  return (
    <>
      <Overlay
        className={styles.mobileMenuOverlay}
        onClick={toggleMobileMenu}
      />
      <Box className={styles.mobileMenu}>
        <Box className={styles.mobileMenuHeader}>
          <ActionIcon
            variant="subtle"
            size="md"
            onClick={toggleMobileMenu}
            aria-label="Close menu"
            className={cx(styles.mobileMenuCloseButton)}
          >
            <></>
          </ActionIcon>
        </Box>

        <Box className={styles.mobileMenuBody}>
          <Text size="xs" className={styles.navSectionTitle}>
            Cwiggo Core
          </Text>
          <CustomSiderNavGroup navItems={navGroupCore} />
          <Text
            size="xs"
            className={cx(
              styles.navSectionTitle,
              styles["navSectionTitle--distribution"],
            )}
          >
            Distribution
          </Text>
          <CustomSiderNavGroup navItems={navGroupDistribution} />
        </Box>

        <Box className={styles.mobileMenuFooter}>
          <Box mb="md">
            <CustomCurrentDatasetPopover w="100%" cwiggoDatasets={Datasets} />
          </Box>
          <CustomSiderAvatarCard />
        </Box>
        <Box mx={12.8} mb="xl" className="border--sky bg--sky-dark-20 br--md">
          <Button
            variant="ghost"
            w="100%"
            onClick={() => {
              setIsMobileMenuOpen(false); // Close mobile menu first
              // Delay opening AI drawer to ensure menu closes first
              setTimeout(() => openAiDrawerGlobally(), 100);
            }}
            aria-label="Open AI Assistant"
            className={styles.aiRobotButton}
          >
            <CustomAiRobot scale={0.7} />
            <Text size="md" fw="bold" className="sky">
              Ai Assistant
            </Text>
          </Button>
        </Box>
      </Box>
    </>
  );
};
